<template>
  <div>
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div v-for="(item, index) in list.taskDetail" :key="index">
      <p class="p-title">
        {{ item.containerNo }}
        <span style="width: 7px; display: inline-block"></span>
        {{ item.skuCode }}
      </p>
      <div class="item-info">
        <ul class="item-ul">
          <li class="item-li">
            <div class="item-left">
              <span>发货编码</span><span>{{ item.sourceNo }}</span>
            </div>
            <div class="item-right">
              <span>shipmentid</span
              ><span>{{ item.shipmentID }}</span>
            </div>
          </li>
          <li class="item-li">
            <div class="item-left">
              <span>是否带电</span><span>{{ item.isElectricityText }}</span>
            </div>
            <div class="item-right">
              <span>供应商</span><span>{{ item.supplierCode }}</span>
            </div>
          </li>
          <li class="item-li">
            <div class="item-left">
              <span>SKU名称</span
              ><span class="hiddenText">{{
                item.productNameCN
              }}</span>
            </div>
          </li>
          <li class="item-li">
            <div class="item-left">
              <span>调入仓</span><span>{{ item.warehouseName }}</span>
            </div>
          </li>
          <li class="item-li">
            <div class="item-left">
              <span>是否退税</span><span>{{ item.isReturnTaxText }}</span>
            </div>
            <div class="item-right">
              <span>品牌</span><span>{{ item.brand }}</span>
            </div>
          </li>
          <li class="item-li">
            <div class="item-left">
              <span>FNSKU</span
              ><span style="word-break: break-all">{{ item.fnsku }}</span>
            </div>
            <div class="item-right">
              <span>型号</span><span>{{ item.model }}</span>
            </div>
          </li>
          <li class="item-li">
            <div class="item-left">
              <span>原SKU</span><span>{{ item.originalSKU }}</span>
            </div>
            <div class="item-right" style="white-space: nowrap">
              <span>{{ item.actualQty }}/{{ item.quantity }}</span
              ><span>(打包数/调拨数)</span>
            </div>
          </li>
          <li class="item-li">
            <div class="item-left">
              <span>{{ item.barMarkDoHandle }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 常规 -->
    <div class="conventionalBox-info">
      <p class="p-title"><span style="color: red">*</span>常规箱信息</p>

      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in info1"
        :key="index"
      >
        <ul>
          <li>
            <div class="btnBox-left">
              <van-field
                size="mini"
                v-model="item.sku"
                placeholder="请扫码SKU"
                right-icon="scan"
                :center="true"
                :border="false"
                clear-trigger="always"
                clearable
                @input="showPicker = true"
                @click-right-icon="scanSku('info1', index)"
                @click-input="scanSkuClick('info1', index)"
              />
            </div>
            <div class="btnBox-right">
              <van-field
                size="mini"
                v-model="item.sourceNo"
                placeholder="发货计划编码"
                :center="true"
                :border="false"
                clear-trigger="always"
                readonly
                clearable
              />
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>单箱数量</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.singleBoxQty"
                @input="inputStockSKUCodeChange(index)"
                @change="inputParseIntNumChange('info1', index, 'singleBoxQty')"
              />
            </div>

            <div>
              <span>X <span style="color: #a5081a">箱数</span></span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxCount"
                @change="inputBoxCodeChange(index)"
                @input="inputParseIntNumChange('info1', index, 'boxCount')"
              />
            </div>
            <div>
              <span>总数：</span>
              <span>{{
                Number(item.singleBoxQty) * Number(item.boxCount) || 0
              }}</span>
              <span
                class="red tips"
                style="left: -22px"
                v-if="item.quantityOut && item.singleBoxQty"
                >装箱数已超调拨数</span
              >
              <span
                class="red tips"
                style="left: -120px"
                v-if="item.BoxNoOrBoxCount"
                >箱号与箱数不符</span
              >
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>箱号起：</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.startBoxNo"
                @input="inputLenChange('info1', index, 'startBoxNo', 0)"
                @change="inputNumChange('info1', index, 'startBoxNo', 0)"
                placeholder="箱号起"
              />
            </div>
            <div>
              <span>箱号止：</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.endBoxNo"
                @input="inputLenChange('info1', index, 'endBoxNo', 0)"
                @change="inputNumChange('info1', index, 'endBoxNo', 0)"
                placeholder="箱号止"
              />
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>长</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxLength"
                @input="inputLenChange('info1', index, 'boxLength', 2)"
                @change="inputNumChange('info1', index, 'boxLength', 2)"
                placeholder="输入长(cm)"
              />
            </div>
            <div>
              <span>宽</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxWidth"
                @input="inputLenChange('info1', index, 'boxWidth', 2)"
                @change="inputNumChange('info1', index, 'boxWidth', 2)"
                placeholder="输入宽(cm)"
              />
            </div>
            <div>
              <span>高</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxHeight"
                @input="inputLenChange('info1', index, 'boxHeight', 2)"
                @change="inputNumChange('info1', index, 'boxHeight', 2)"
                placeholder="输入高(cm)"
              />
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>毛重</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxWeight"
                @input="inputLenChange('info1', index, 'boxWeight', 2)"
                @change="inputNumChange('info1', index, 'boxWeight', 2)"
                placeholder="请输入毛重(kg)"
              />
            </div>
            <div class="btnCls">
              <span class="delInfo" @click="del(1, index)">{{
                info1.length === 1 ? "清空" : "删除"
              }}</span>
              <span class="addInfo" @click="add(1)">添加</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 混箱 -->
    <div class="conventionalBox-info">
      <p class="p-title">混装箱信息</p>

      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in info3"
        :key="index"
      >
        <ul>
          <li v-for="(itemBD, indexBD) in item.boxDetail" :key="indexBD">
            <div class="btnBox-left">
              <van-field
                size="mini"
                v-model="itemBD.sku"
                :placeholder="`请扫码SKU${indexBD + 1}`"
                right-icon="scan"
                :center="true"
                :border="false"
                clear-trigger="always"
                clearable
                @input="showPicker = true"
                @click-right-icon="
                  scanSku('info3', index, 'boxDetail', indexBD)
                "
                @click-input="
                  scanSkuClick('info3', index, 'boxDetail', indexBD)
                "
                @clear="clearSku(index, indexBD)"
              />
              <van-field
                size="mini"
                type="digit"
                v-model="itemBD.qty"
                :placeholder="`SKU${indexBD + 1}单箱数量`"
                :center="true"
                :border="false"
                clear-trigger="always"
                clearable
                maxlength="10"
              />
            </div>
            <div class="btnBox-right" style="position: relative">
              <van-field
                size="mini"
                v-model="itemBD.sourceNo"
                :placeholder="`SKU${indexBD + 1}发货计划编码`"
                :center="true"
                :border="false"
                clear-trigger="always"
                readonly
                clearable
              />
              <span
                class="red tips"
                style="left: 7px; top: 64px"
                v-if="item.quantityOut && itemBD.qty"
                >装箱数已超调拨数</span
              >
            </div>
          </li>
          <li style="position: relative">
            <!-- <span style="color:red;line-height:20px;" v-if="item.notMixing">不可混装！存在shipmentid，供应商不一致！</span> -->
          </li>
          <li>
            <div class="add" @click="mixinsAdd(index)">+</div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>长</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxLength"
                @input="inputLenChange('info3', index, 'boxLength', 2)"
                @change="inputNumChange('info3', index, 'boxLength', 2)"
                placeholder="输入长(cm)"
              />
            </div>
            <div>
              <span>宽</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxWidth"
                @input="inputLenChange('info3', index, 'boxWidth', 2)"
                @change="inputNumChange('info3', index, 'boxWidth', 2)"
                placeholder="输入宽(cm)"
              />
            </div>
            <div>
              <span>高</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxHeight"
                @input="inputLenChange('info3', index, 'boxHeight', 2)"
                @change="inputNumChange('info3', index, 'boxHeight', 2)"
                placeholder="输入高(cm)"
              />
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>毛重</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxWeight"
                @input="inputLenChange('info3', index, 'boxWeight', 2)"
                @change="inputNumChange('info3', index, 'boxWeight', 2)"
                placeholder="请输入毛重(kg)"
              />
            </div>
            <div>
              <span>箱号</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxNumber"
                @input="inputLenChange('info3', index, 'boxNumber', 0)"
                @change="inputNumChange('info3', index, 'boxNumber', 0)"
                placeholder="输入箱号"
              />
            </div>
            <div class="btnCls">
              <span class="delInfo" @click="del(3, index)">{{
                info3.length === 1 ? "清空" : "删除"
              }}</span>
              <span class="addInfo" @click="add(3)">添加</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 尾箱 -->
    <div class="conventionalBox-info">
      <p class="p-title">尾箱信息</p>

      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in info2"
        :key="index"
      >
        <ul>
          <li>
            <div class="btnBox-left">
              <van-field
                size="mini"
                v-model="item.sku"
                placeholder="请扫码SKU"
                right-icon="scan"
                :center="true"
                :border="false"
                clear-trigger="always"
                clearable
                @input="showPicker = true"
                @click-right-icon="scanSku('info2', index)"
                @click-input="scanSkuClick('info2', index)"
              />
            </div>
            <div class="btnBox-right"></div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>单箱数量</span>
              <input
                type="number"
                class="volume fl"
                style="max-width: 32%"
                v-model="item.singleBoxQty"
                @input="inputStockSKUCodeChange2(index)"
                @change="inputParseIntNumChange('info2', index, 'singleBoxQty')"
              />
            </div>
            <span
              class="red tips"
              style="left: 60px"
              v-if="item.quantityOut && item.singleBoxQty"
              >装箱数已超调拨数</span
            >
          </li>
          <li class="singleBoxLi">
            <div>
              <span>长</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxLength"
                @input="inputLenChange('info2', index, 'boxLength', 2)"
                @change="inputNumChange('info2', index, 'boxLength', 2)"
                placeholder="输入长(cm)"
              />
            </div>
            <div>
              <span>宽</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxWidth"
                @input="inputLenChange('info2', index, 'boxWidth', 2)"
                @change="inputNumChange('info2', index, 'boxWidth', 2)"
                placeholder="输入宽(cm)"
              />
            </div>
            <div>
              <span>高</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxHeight"
                @input="inputLenChange('info2', index, 'boxHeight', 2)"
                @change="inputNumChange('info2', index, 'boxHeight', 2)"
                placeholder="输入高(cm)"
              />
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>毛重</span>
              <input
                type="number"
                class="volume fl"
                style="max-width: 40%"
                v-model="item.boxWeight"
                @input="inputLenChange('info2', index, 'boxWeight', 2)"
                @change="inputNumChange('info2', index, 'boxWeight', 2)"
                placeholder="请输入毛重(kg)"
              />
            </div>
            <div>
              <span>箱号</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxNumber"
                @input="inputLenChange('info2', index, 'boxNumber', 0)"
                @change="inputNumChange('info2', index, 'boxNumber', 0)"
                placeholder="输入箱号"
              />
            </div>
            <div class="btnCls">
              <span class="delInfo" @click="del(2, index)">{{
                info2.length === 1 ? "清空" : "删除"
              }}</span>
              <span class="addInfo" @click="add(2)">添加</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="photo" style="width: 100%; margin-top: 10px">
      <div
        class="p-title"
        style="float: left; line-height: 35px; margin-right: 8px"
      >
        <span style="color: red">*</span>打包方式
      </div>
      <van-field
        v-model="list.packagingTypeName"
        placeholder="请选择打包方式"
        @focus="locationFocus"
        style="width: 200px"
        readonly="readonly"
      />
      <input type="hidden" v-model="list.packagingTypeId" />
    </div>
    <div class="barcodeMethodClass">
      <div class="p-title"><span style="color: red">*</span>条码方式</div>
      <div>
        <van-radio-group v-model="WarehouseLable" direction="horizontal">
          <van-radio name="1" shape="square" icon-size="14px">货主贴</van-radio>
          <van-radio name="2" shape="square" icon-size="14px">仓库贴</van-radio>
        </van-radio-group>
      </div>
    </div>

    <!-- 照片 -->
    <div class="photo">
      <p class="p-title">
        <span style="color: red">*</span>打包照片<span style="font-weight: 400"
          >（最少1张）</span
        >
      </p>

      <div class="sign-photo-cpntent">
        <div class="sign-photo-box">
          <ul>
            <li
              class="sign-photo-item"
              v-for="(item, index) in skuImg"
              :key="index"
            >
              <span class="delete-icon" @click="deleteImg(index)">x</span>
              <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
              <img
                :src="item"
                class="sign-photo-item-img"
                alt=""
                @click="previewImage(item)"
              />
            </li>

            <li class="sign-photo-btn">
              <div class="photo">
                <input
                  class="img hidden"
                  @change="changeImg()"
                  type="file"
                  name="cover"
                  ref="inputer"
                  accept="image/*"
                  multiple
                />
                <p @click="chooseImage">
                  <i class="el-icon-camera"></i>
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div class="sign-photo-save">
          <button class="submit-btn" @click="submit">保存</button>
        </div>
      </div>
    </div>

    <!-- SKU扫码下拉选项 -->
    <van-popup
      v-model="showPicker"
      round
      position="bottom"
      get-container="#app"
    >
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
    <!-- 打包方式下拉 -->
    <van-popup
      v-model="typeShowPicker"
      round
      position="bottom"
      get-container="#app"
    >
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        :columns="packagingTypeList"
        @cancel="typeShowPicker = false"
        @confirm="onConfirmType"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
  ImagePreview,
  Radio,
  RadioGroup,
} from "vant";
import { mixins } from "../mobileMixins";
import { mapMutations } from "vuex";
import {
  getBaleSkuDetail,
  getBaleContainerDetail,
  getBaleHasBoxNum,
  AddReadyTaskPackaging,
} from "@/api/mobile/bale_api.js";
import { BaseApiUrl } from "@/api/axios_config";
import axios from "axios";
export default {
  data() {
    return {
      WarehouseLable: undefined,
      list: {},
      boxMaxNo:0,
      info1: [
        // 常规
        {
          sku: "",
          sourceNo: "",
          singleBoxQty: "",
          boxCount: "",
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
          startBoxNo: "",
          endBoxNo: "",
        },
      ],
      info2: [
        // 尾箱
        {
          singleBoxQty: "",
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
        },
      ],
      info3: [
        // 混箱
        {
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
          boxDetail: [
            { sku: "", qty: "", sourceNo: "" },
            { sku: "", qty: "", sourceNo: "" },
          ],
        },
      ],
      skuImg: [],
      imgFiles: [],
      skuCode: "",
      itemName: {
        sku: "SKU",
        sourceNo: "发货编码",
        singleBoxQty: "单箱数量",
        qty: "单箱数量",
        boxCount: "箱数",
        boxLength: "长",
        boxWidth: "宽",
        boxHeight: "高",
        boxWeight: "毛重",
        startBoxNo: "箱号起",
        endBoxNo: "箱号止",
      },
      showPicker: false,

      columns: [],
      saveScanSkuName: "",
      isEdit: false, // 是否编辑
      saveImgUrlArr: [],
      saveMaxNoArr: [],
      shippingPlanDetailIDs: [],
      savePlanArr: [],
      packagingTypeList: [], //打包方式
      typeShowPicker: false,
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.name]: ImagePreview,
    [Field.name]: Field,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getDetail();
    },
    createBoxNo()
    {
      this.boxMaxNo=0;
      //常规箱
      this.info1.forEach((item, i) => {
        if(item.singleBoxQty>0 && item.boxCount>0)
        {
          item.startBoxNo=this.boxMaxNo+1;
          item.endBoxNo=this.boxMaxNo+item.boxCount;
          this.boxMaxNo=this.boxMaxNo+item.boxCount;
        }
      });
      //混装箱
      this.info3.forEach((item,i)=>{
        console.info(item);
        const { boxDetail } =item;
        let flag = false;
        boxDetail.forEach((boxD, b) => {
          const {qty } = boxD;
          if (qty) {
            flag = true;
          }
        });
        if(flag)
        {
          item.boxNumber=this.boxMaxNo+1;
          this.boxMaxNo=this.boxMaxNo+1;
        }
      });
      console.info(this.info2);
      //尾箱
       this.info2.forEach((item, i) => {
        if(item.singleBoxQty>0)
        {
          item.boxNumber=this.boxMaxNo+1;
          this.boxMaxNo=this.boxMaxNo+1;
        }
      });
    },
    onConfirmType(val) {
      this.$set(this.list, "packagingTypeId", val.packagingTypeId);
      this.$set(this.list, "packagingTypeName", val.text);
      this.typeShowPicker = false;
    },
    locationFocus() {
      this.typeShowPicker = true;
    },
    onConfirm(val) {
      let v = val.text.split("(");
      let sNo = v[1].split(")")[0];
      let shippingPlanDetailID = val.shippingPlanDetailID;
      const s = this.saveScanSkuName.split("-");
      if (s[2]) {
        // 混箱
        let arr = [];
        let arr1 = [];
        let arr2 = [];
        const mixing = this[s[0]][s[1]][s[2]];
        mixing.forEach((item, i) => {
          item.shippingPlanDetailID && arr.push(item.shippingPlanDetailID);
          item.shipmentID && arr1.push(item.shipmentID);
          item.supplierCode && arr2.push(item.supplierCode);
        });
        if (
          arr.includes(shippingPlanDetailID) &&
          this[s[0]][s[1]][s[2]][[s[3]]].shippingPlanDetailID !=
            shippingPlanDetailID
        ) {
          Toast("当前混箱存在相同发货计划");
          return;
        }
        // this[s[0]][s[1]].forEach((item,i)=>{
        // 	this.$set(this[s[0]][i],'notMixing',false)
        // })
        if (arr1.length && arr2.length) {
          if (
            arr1.includes(val.shipmentID) &&
            arr2.includes(val.supplierCode)
          ) {
            // shipmentID和supplierCode是否一致
            this.$set(
              this[s[0]][s[1]][s[2]][[s[3]]],
              "shippingPlanDetailID",
              shippingPlanDetailID
            );
            this.$set(this[s[0]][s[1]][s[2]][[s[3]]], "sku", v[0]);
            this.$set(this[s[0]][s[1]][s[2]][[s[3]]], "sourceNo", sNo);
            this.$set(
              this[s[0]][s[1]][s[2]][[s[3]]],
              "shipmentID",
              val.shipmentID
            );
            this.$set(
              this[s[0]][s[1]][s[2]][[s[3]]],
              "supplierCode",
              val.supplierCode
            );
          } else {
            // this.$set(this[s[0]][s[1]],'notMixing',true)
            Toast("不可混装！存在shipmentid，供应商不一致！");
            return;
          }
        } else {
          this.$set(
            this[s[0]][s[1]][s[2]][[s[3]]],
            "shippingPlanDetailID",
            shippingPlanDetailID
          );
          this.$set(this[s[0]][s[1]][s[2]][[s[3]]], "sku", v[0]);
          this.$set(this[s[0]][s[1]][s[2]][[s[3]]], "sourceNo", sNo);
          this.$set(
            this[s[0]][s[1]][s[2]][[s[3]]],
            "shipmentID",
            val.shipmentID
          );
          this.$set(
            this[s[0]][s[1]][s[2]][[s[3]]],
            "supplierCode",
            val.supplierCode
          );
        }
      } else {
        // 整箱，尾箱
        this.$set(this[s[0]][s[1]], "sku", v[0]);
        this.$set(this[s[0]][s[1]], "sourceNo", sNo);
        this.$set(
          this[s[0]][s[1]],
          "shippingPlanDetailID",
          shippingPlanDetailID
        );
      }
      this.showPicker = false;
    },

    add(type) {
      let obj = {};
      if (type === 1) {
        // 整箱
        obj = {
          sku: "",
          sourceNo: "",
          singleBoxQty: "",
          boxCount: "",
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
        };
      } else if (type === 2) {
        // 尾箱
        obj = {
          sku: "",
          singleBoxQty: "",
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
        };
      } else {
        // 混箱
        obj = {
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
          boxDetail: [
            { sku: "", qty: "", sourceNo: "" },
            { sku: "", qty: "", sourceNo: "" },
          ],
        };
      }
      this[`info${type}`].push(obj);
    },

    del(type, i) {
      const that = this;
      const len = that[`info${type}`].length;
      const msg = len === 1 ? "清空" : "删除";
      Dialog.confirm({
        title: msg,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        message: `确认进行${msg}操作吗？`,
      })
        .then(() => {
          if (len === 1) {
            that[`info${type}`].splice(i, 1);
            that.add(type);
            return;
          }

          that[`info${type}`].splice(i, 1);
        })
        .catch(() => {});
    },

    mixinsAdd(i) {
      this.info3[i].boxDetail.push({ sku: "", qty: "", sourceNo: "" });
    },

    getDetail() {
      const data = {};
      if (this.$route.query.shippingPlanDetailID) {
        data.shippingPlanDetailIDS = this.$route.query.shippingPlanDetailID;
        data.stockingTaskID = this.$route.query.stockingTaskID;
        this.getForSKU(data);
      }
      if (this.$route.query.containerNo) {
        data.containerNo = this.$route.query.containerNo;
        this.getForContainer(data);
      }
    },

    // 根据SKU获取信息
    getForSKU(data) {
      getBaleSkuDetail(data).then((res) => {
        if (res.status === 200 && res.success) {
          const { response } = res;
          this.WarehouseLable = response.warehouseLable + "";
          let flag = false;
          if (response.wholeCase.length) {
            this.info1 = response.wholeCase;
            response.wholeCase.forEach((item) => {
              if (item.stockingBoxSumID) {
                flag = true;
              }
              if (
                item.shippingPlanDetailID &&
                !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)
              ) {
                this.shippingPlanDetailIDs.push(item.shippingPlanDetailID);
              }
            });
          }

          if (response.theTrunk.length) {
            response.theTrunk.forEach((item) => {
              if (item.stockingBoxSumID) {
                flag = true;
              }
              if (
                item.shippingPlanDetailID &&
                !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)
              ) {
                this.shippingPlanDetailIDs.push(item.shippingPlanDetailID);
              }
            });
            this.info2 = response.theTrunk;
          }

          if (response.mixingTank.length) {
            response.mixingTank.forEach((item) => {
              item.boxDetail.forEach((item2) => {
                if (
                  item2.shippingPlanDetailID &&
                  !this.shippingPlanDetailIDs.includes(
                    item2.shippingPlanDetailID
                  )
                ) {
                  this.shippingPlanDetailIDs.push(item2.shippingPlanDetailID);
                }
              });
              if (item.stockingBoxSumID) {
                flag = true;
              }
            });
            this.info3 = response.mixingTank;
          }

          if (response.urlPath && response.urlPath.length) {
            response.urlPath.forEach((item, i) => {
              response.urlPath[
                i
              ] = `data:image/jpg;base64,${response.urlPath[i]}`;
            });

            this.skuImg = response.urlPath;
          }

          this.saveImgUrlArr = response.imgUrlList || [];

          let arr = [];
          response.taskDetail.forEach((item) => {
            arr.push({
              text: `${item.skuCode}(${item.sourceNo})`,
              shippingPlanDetailID: item.shippingPlanDetailID,
              supplierCode: item.supplierCode,
              shipmentID: item.shipmentID,
            });
          });
          this.columns = arr;

          this.list = response;

          let typeArr = [];
          response.packagingTypeList.forEach((item) => {
            typeArr.push({
              text: `${item.packagingTypeName}`,
              packagingTypeId: item.packagingTypeId,
            });
          });

          this.packagingTypeList = typeArr;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    // 根据货柜号获取信息
    getForContainer(data) {
      getBaleContainerDetail(data).then((res) => {
        if (res.status === 200 && res.success) {
          const { response } = res;
          this.WarehouseLable = response.warehouseLable + "";
          let flag = false;
          if (response.wholeCase.length) {
            this.info1 = response.wholeCase;
            response.wholeCase.forEach((item) => {
              if (item.stockingBoxSumID) {
                flag = true;
              }
              if (
                item.shippingPlanDetailID &&
                !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)
              ) {
                this.shippingPlanDetailIDs.push(item.shippingPlanDetailID);
              }
            });
          }

          if (response.theTrunk.length) {
            response.theTrunk.forEach((item) => {
              if (item.stockingBoxSumID) {
                flag = true;
              }
              if (
                item.shippingPlanDetailID &&
                !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)
              ) {
                this.shippingPlanDetailIDs.push(item.shippingPlanDetailID);
              }
            });
            this.info2 = response.theTrunk;
          }

          if (response.mixingTank.length) {
            response.mixingTank.forEach((item) => {
              item.boxDetail.forEach((item2) => {
                if (
                  item2.shippingPlanDetailID &&
                  !this.shippingPlanDetailIDs.includes(
                    item2.shippingPlanDetailID
                  )
                ) {
                  this.shippingPlanDetailIDs.push(item2.shippingPlanDetailID);
                }
              });
              if (item.stockingBoxSumID) {
                flag = true;
              }
            });
            this.info3 = response.mixingTank;
          }

          // 判断是否编辑
          if (flag) {
            this.isEdit = true;
          }

          if (response.urlPath && response.urlPath.length) {
            response.urlPath.forEach((item, i) => {
              response.urlPath[
                i
              ] = `data:image/jpg;base64,${response.urlPath[i]}`;
            });

            this.skuImg = response.urlPath;
          }

          this.saveImgUrlArr = response.imgUrlList || [];

          let arr = [];
          response.taskDetail.forEach((item) => {
            arr.push({
              text: `${item.skuCode}(${item.sourceNo})`,
              shippingPlanDetailID: item.shippingPlanDetailID,
              supplierCode: item.supplierCode,
              shipmentID: item.shipmentID,
            });
          });
          this.columns = arr;

          let typeArr = [];
          response.packagingTypeList.forEach((item) => {
            typeArr.push({
              text: `${item.packagingTypeName}`,
              packagingTypeId: item.packagingTypeId,
            });
          });

          this.packagingTypeList = typeArr;
          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    // 处理整箱的单箱数量
    inputStockSKUCodeChange(i) {
      if (this.info1[i].singleBoxQty.length > 10)
        this.$set(
          this.info1[i],
          "singleBoxQty",
          this.info1[i].singleBoxQty.slice(0, 10)
        );

      if (!this.info1[i].sku) {
        Toast("请先选择SKU");
        this.$set(this.info1[i], "singleBoxQty", "");
        return;
      }
    },
    // 处理整箱的箱数
    inputBoxCodeChange(i) {
      if (String(this.info1[i].boxCount).length > 10)
        this.$set(
          this.info1[i],
          "boxCount",
          Number(String(this.info1[i].boxCount).slice(0, 10))
        );
    },
    // 处理尾箱的单箱数量
    inputStockSKUCodeChange2(i) {
      if (this.info2[i].singleBoxQty.length > 10)
        this.$set(
          this.info2[i],
          "singleBoxQty",
          this.info2[i].singleBoxQty.slice(0, 10)
        );
    },

    // 前端验证打包数是否大于调拨数
    checkActualQty() {
      const that = this;
      let arr = [],
        obj1 = {};
      this.savePlanArr = [];

      this.list.taskDetail.forEach((item, i) => {
        obj1[item.sourceNo + "-" + item.skuCode] = [0];
      });

      for (let i = 0; i < this.info1.length; i++) {
        for (const key in obj1) {
          if (key == this.info1[i].sourceNo + "-" + this.info1[i].sku) {
            obj1[key].push(
              Number(this.info1[i].singleBoxQty) *
                Number(this.info1[i].boxCount) || 0
            );
          }
        }
      }

      for (let j = 0; j < this.info2.length; j++) {
        for (const key in obj1) {
          if (key == this.info2[j].sourceNo + "-" + this.info2[j].sku) {
            obj1[key].push(Number(this.info2[j].singleBoxQty) || 0);
          }
        }
      }

      for (let k = 0; k < this.info3.length; k++) {
        this.info3[k].boxDetail.forEach((item) => {
          for (const key in obj1) {
            if (key == item.sourceNo + "-" + item.sku) {
              obj1[key].push(Number(item.qty) || 0);
            }
          }
        });
      }

      function reset(bool) {
        that.info1.forEach((item, i) => {
          that.$set(that.info1[i], "quantityOut", bool);
        });
        that.info2.forEach((item, i) => {
          that.$set(that.info2[i], "quantityOut", bool);
        });
        that.info3.forEach((item, i) => {
          that.$set(that.info3[i], "quantityOut", bool);
        });
      }

      reset(false);

      let arr2 = [],
        flag1 = false,
        flag2 = false;
      this.list.taskDetail.forEach((item, i) => {
        for (const key in obj1) {
          if (key == item.sourceNo + "-" + item.skuCode) {
            var sum = obj1[key].reduce(function (prev, cur) {
              return prev + cur;
            });
            if (item.quantity < sum) {
              // 存在打包数 大于 调拨数的计划
              flag1 = true;
            }
            if (item.quantity > sum) {
              // 存在打包数 小于 调拨数的计划
              arr2.push(key);
              flag2 = true;
            }
          }
        }
        // arr3.push(item.quantity)
      });

      // 计算总调拨数
      // var sum3 = arr3.reduce(function(prev,cur){
      // 	return prev + cur
      // })

      // for (const key in obj1) {
      // 	var sum4 = obj1[key].reduce(function(prev,cur){
      // 		return prev + cur
      // 	})
      // 	arr4.push(sum4)
      // }

      // // 计算总打包数
      // var sum5 = arr4.reduce(function(prev,cur){
      // 	return prev + cur
      // })

      if (flag1) {
        reset(true);
        return 1;
      }

      if (flag2) {
        this.savePlanArr = arr2;
        return 2;
      }
      return 3;
    },

    // 检测是否写完全部信息
    checkAllInfo() {
      const arr1 = [
        "sku",
        "sourceNo",
        "singleBoxQty",
        "boxCount",
        "boxLength",
        "boxWidth",
        "boxHeight",
        "boxWeight",
        "startBoxNo",
        "endBoxNo",
      ];
      const arr2 = [
        "singleBoxQty",
        "boxLength",
        "boxWidth",
        "boxHeight",
        "boxWeight",
      ];
      const arr3 = [
        "sku",
        "sourceNo",
        "boxLength",
        "boxWidth",
        "boxHeight",
        "boxWeight",
        "qty",
      ];

      for (let i = 0; i < this.info1.length; i++) {
        const {
          sku,
          sourceNo,
          singleBoxQty,
          boxCount,
          boxLength,
          boxWidth,
          boxHeight,
          boxWeight,
          startBoxNo,
          endBoxNo,
        } = this.info1[i];
        if (
          sku ||
          sourceNo ||
          singleBoxQty ||
          boxCount ||
          boxLength ||
          boxWidth ||
          boxHeight ||
          boxWeight ||
          startBoxNo ||
          endBoxNo
        ) {
          for (const key in this.info1[i]) {
            if (arr1.includes(key)) {
              if (!this.info1[i][key] || this.info1[i][key] === "0.00") {
                this.showsound(false);
                Toast(`请输入整箱${this.itemName[key]}`);
                return false;
              }
            }
          }
        }
      }

      // 尾箱一个输入框有值，其它的都必填
      for (let i = 0; i < this.info2.length; i++) {
        const { singleBoxQty, boxLength, boxWidth, boxHeight, boxWeight } =
          this.info2[i];
        if (singleBoxQty || boxLength || boxWidth || boxHeight || boxWeight) {
          for (const key in this.info2[i]) {
            if (arr2.includes(key)) {
              if (!this.info2[i][key] || this.info2[i][key] === "0.00") {
                this.showsound(false);
                Toast(`请输入尾箱${this.itemName[key]}`);
                return false;
              }
            }
          }
        }
      }

      // 混箱一个输入框有值，其它的都必填
      this.info3.forEach((item, i) => {
        delete this.info3[i].sku;
        delete this.info3[i].sourceNo;
        delete this.info3[i].singleBoxQty;
      });
      for (let i = 0; i < this.info3.length; i++) {
        const { boxLength, boxWidth, boxHeight, boxWeight, boxDetail } =
          this.info3[i];
        let flag = false;
        boxDetail.forEach((item, i) => {
          const { sku, sourceNo, qty } = item;
          if (sku || sourceNo || qty) {
            flag = true;
          }
        });
        if (boxLength || boxWidth || boxHeight || boxWeight || flag) {
          for (const key in this.info3[i]) {
            if (key == "boxDetail") {
              for (let l = 0; l < this.info3[i].boxDetail.length; l++) {
                const ss = this.info3[i].boxDetail[l];
                for (const key2 in ss) {
                  if (arr3.includes(key2)) {
                    if (!ss[key2] || ss[key2] === "0.00") {
                      this.showsound(false);
                      Toast(`请输入混箱${this.itemName[key2]}`);
                      return false;
                    }
                  }
                }
              }
            } else {
              if (arr3.includes(key) && key != "boxDetail") {
                if (!this.info3[i][key] || this.info3[i][key] === "0.00") {
                  this.showsound(false);
                  Toast(`请输入混箱${this.itemName[key]}`);
                  return false;
                }
              }
            }
          }
        }
      }
      return true;
    },

    // 检测填写的SKU是否存在
    checkSku(data) {
      let arr = [];
      this.list.taskDetail.forEach((item, i) => {
        arr.push(item.skuCode);
      });
      for (let i = 0; i < data.length; i++) {
        if (data[i].boxType != 2) {
          if (!arr.includes(data[i].sku)) {
            return false;
          }
        } else {
          for (let j = 0; j < data[i].boxDetail.length; j++) {
            if (!arr.includes(data[i].boxDetail[j].sku)) {
              return false;
            }
          }
        }
      }
      return true;
    },
    showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    // 提交
    submit() {
      const that = this;

      if (!this.checkAllInfo()) return;

      if (this.list.packagingTypeId === 0 || this.list.packagingTypeId === "")
        {
          this.showsound(false);
          return Toast("请选择打包方式");
        }
      if (!this.WarehouseLable) 
      {
        this.showsound(false);
        return Toast("请选择条码方式");
      }
      if (this.saveImgUrlArr.length < 1) 
      {
        this.showsound(false);
        return Toast("最少1张照片");
      }

      const data = [],
        saveIDS = [];
      // 整箱
      this.info1.forEach((item, i) => {
        if (item.boxCount) {
          item.boxType = 1;
          item.stockingBoxSumID =
            item.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID;
          item.stockingTaskID =
            item.stockingTaskID || this.list.taskDetail[0].stockingTaskID;
          item.stockingBoxListID =
            item.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID;
          data.push(item);
          if (
            item.shippingPlanDetailID &&
            !saveIDS.includes(item.shippingPlanDetailID)
          ) {
            saveIDS.push(item.shippingPlanDetailID);
          }
        }
      });

      // 尾箱
      this.info2.forEach((item, i) => {
        if (item.singleBoxQty) {
          item.boxType = 3;
          item.boxCount = 1;
          item.startBoxNo = item.boxNumber;
          item.endBoxNo = item.boxNumber;
          item.stockingBoxSumID =
            item.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID;
          item.stockingTaskID =
            item.stockingTaskID || this.list.taskDetail[0].stockingTaskID;
          item.stockingBoxListID =
            item.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID;
          data.push(item);
          if (
            item.shippingPlanDetailID &&
            !saveIDS.includes(item.shippingPlanDetailID)
          ) {
            saveIDS.push(item.shippingPlanDetailID);
          }
        }
      });

      // 混箱
      this.info3.forEach((item, i) => {
        let obj = item;
        if (obj.boxLength) {
          obj.boxType = 2;
          obj.boxCount = 1;
          obj.startBoxNo = obj.boxNumber;
          obj.endBoxNo = obj.boxNumber;
          // obj.stockingBoxSumID = obj.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID
          obj.stockingTaskID =
            obj.stockingTaskID || this.list.taskDetail[0].stockingTaskID;
          // obj.stockingBoxListID = obj.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID

          obj.boxDetail.forEach((item2, i2) => {
            delete obj.boxDetail[i2].shipmentID;
            delete obj.boxDetail[i2].supplierCode;
            if (
              item2.shippingPlanDetailID &&
              !saveIDS.includes(item2.shippingPlanDetailID)
            ) {
              saveIDS.push(item2.shippingPlanDetailID);
            }
          });
          data.push(item);
        }
      });

      if (data.length) {
        if (!this.checkSku(data))
          {
            this.showsound(false);
            return Toast("存在非当前发货计划的SKU,请检查后再提交");
          }

        if (this.checkActualQty() === 1) {
          this.showsound(false);
          return Toast("装箱数已超调拨数");
        } else if (this.checkActualQty() === 2) {
          let sourceNoArr = [];
          this.savePlanArr.forEach((item, i) => {
            const arrs = item.split("-");
            sourceNoArr.push(`发货计划：${arrs[0]}`, `sku：${arrs[1]}`);
          });
          Dialog.confirm({
            title: "确认",
            confirmButtonText: "确认无误",
            cancelButtonText: "取消",
            message: `${sourceNoArr.toString()}，实际打包数量小于调拨数量，请确认是否无误？`,
          })
            .then(() => {
              let info3DetailFlag = false;

              let data2 = JSON.parse(JSON.stringify(data));

              data2.forEach((item, i) => {
                delete data2[i].quantityOut;
                delete data2[i].BoxNoOrBoxCount;
                delete data2[i].boxNoRepet;

                if (item.boxType === 2) {
                  if (item.boxDetail.length < 2) {
                    info3DetailFlag = true;
                  }
                }
              });

              if (info3DetailFlag) 
              {
                this.showsound(false);
                return Toast("请输入完整混箱信息");
              }

              let ids = Array.from(
                new Set(saveIDS.concat(this.shippingPlanDetailIDs))
              );
              const obj = {
                boxList: data2,
                file: this.saveImgUrlArr,
                WarehouseLable: this.WarehouseLable,
                shippingPlanDetailIDs: ids.toString() || "",
                packagingTypeId: this.list.packagingTypeId,
              };

              Toast.loading({
                message: "打包中...",
                forbidClick: true,
                overlay: true,
                duration: 0,
              });

              console.log("obj", obj);
              AddReadyTaskPackaging(obj).then((res) => {
                Toast.clear();
                if (res.status === 200 && res.success) {
                  this.showsound(true);
                  Toast.success(res.msg || "打包成功");

                  setTimeout(function () {
                    that.$router.go(-1);
                  }, 1500);
                } else {
                  this.showsound(false);
                  Toast.fail(res.msg);
                }
              });
            })
            .catch(() => {
              return;
            });
        } else {
          let info3DetailFlag = false;

          let data2 = JSON.parse(JSON.stringify(data));

          data2.forEach((item, i) => {
            delete data2[i].quantityOut;
            delete data2[i].BoxNoOrBoxCount;
            delete data2[i].boxNoRepet;

            if (item.boxType === 2) {
              if (item.boxDetail.length < 2) {
                info3DetailFlag = true;
              }
            }
          });

          if (info3DetailFlag) 
          {
            this.showsound(false);
            return Toast("请输入完整混箱信息");
          }

          let ids = Array.from(
            new Set(saveIDS.concat(this.shippingPlanDetailIDs))
          );
          const obj = {
            boxList: data2,
            file: this.saveImgUrlArr,
            shippingPlanDetailIDs: ids.toString() || "",
            WarehouseLable: this.WarehouseLable,
            packagingTypeId: this.list.packagingTypeId,
          };

          Toast.loading({
            message: "打包中...",
            forbidClick: true,
            overlay: true,
            duration: 0,
          });

          console.log("obj", obj);
          AddReadyTaskPackaging(obj).then((res) => {
            Toast.clear();
            if (res.status === 200 && res.success) {
              this.showsound(true);
              Toast.success(res.msg || "打包成功");
              setTimeout(function () {
                that.$router.go(-1);
              }, 1500);
            } else {
              this.showsound(false);
              Toast.fail(res.msg);
            }
          });
        }
      } else {
        this.showsound(false);
        return Toast("请至少输入一种类型");
      }
    },

    scanSku(m, i, n, i2) {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          let flag = false;
          that.columns.forEach((item) => {
            const t = item.text.split("(")[0];
            if (t === a.resultStr) {
              flag = true; // 存在sku
            }
          });

          if (!flag) {
            this.showsound(false);
            Toast("请扫描属于当前计划的SKU");
          } else {
            that.showPicker = true;
            that.saveScanSkuName =
              `${m}-${i}` + (n ? `-${n}` : "") + (i2 != null ? `-${i2}` : "");
            if (n) {
              that.$set(that[m][i][n][i2], "sku", a.resultStr);
            } else {
              that.$set(that[m][i], "sku", a.resultStr);
            }
          }
        },
      });
    },

    scanSkuClick(m, i, n, i2) {
      this.saveScanSkuName =
        `${m}-${i}` + (n ? `-${n}` : "") + (i2 != null ? `-${i2}` : "");
      this.showPicker = !this.showPicker;
    },

    deleteImg(i) {
      this.skuImg.splice(i, 1);
      // this.imgFiles.splice(i,1)
      this.saveImgUrlArr.splice(i, 1);
    },

    changeImg() {
      const img = document.getElementsByClassName("img")[0];
      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.handleFiles(imgList);

      this.submitImg();
    },

    chooseImage() {
      document.getElementsByClassName("img")[0].click();
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      const that = this;
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
          that.$set(that.skuImg, that.skuImg.length, e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    submitImg() {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArr.push(...res.data.response);
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },

    clearSku(i, i2) {
      this.$set(this.info3[i].boxDetail[i2], "shipmentID", "");
      this.$set(this.info3[i].boxDetail[i2], "supplierCode", "");
      this.$set(this.info3[i].boxDetail[i2], "shippingPlanDetailID", "");
    },

    inputLenChange(name, i, field, fix = 1) {
      let s = this[name][i][field];
      if (s.includes(".")) {
        const m = s.split(".")[0];
        if (m.length > 3) {
          this.$set(this[name][i], field, Number(`${m.slice(0, 3)}.${m[1]}`));
        }
      } else {
        if (s.length > 4) {
          this.$set(this[name][i], field, this[name][i][field].slice(0, 4));
        }
      }
    },

    inputNumChange(name, i, field, fix = 1) {
      function toF(n, fix) {
        return Number(n).toFixed(fix);
      }

      let s = this[name][i][field];

      let num = toF(s, fix);
      if (num < 0) {
        Toast("请输入正数");
        num = toF(0, fix);
      }
      this.$set(this[name][i], field, num);

      if (name === "info3" && field === "boxLength") {
        this.createBoxNo();
      }
    },

    inputParseIntNumChange(name, i, field) {
      let num = Number(this[name][i][field]);
      if (num < 0) {
        Toast("请输入正整数");
        num = Math.abs(num);
      }
      this.$set(this[name][i], field, parseInt(num));

      if (name === "info1" && field === "boxCount") {
        if (String(this.info1[i].boxCount).length > 10)
          this.$set(
            this.info1[i],
            "boxCount",
            Number(String(this.info1[i].boxCount).slice(0, 10))
          );
      }
      this.createBoxNo();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    padding-left: 18.5%;
    .item-li {
      display: flex;
      align-content: flex-start;
      word-break: break-all;
      margin-bottom: 4px;
      padding-bottom: 4px;
      & > div {
        flex: 1;
        line-height: 25px;
        max-width: 100%;
        display: flex;
        & > span {
          vertical-align: text-top;
          &:first-child {
            text-align: start;
            padding-right: 10px;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
@media (max-width: 450px) {
  .item-info {
    font-size: 12px;
    .item-ul {
      padding: 0 2%;
      .item-li {
        .item-right {
          margin-left: 3%;
        }
        & > div {
          line-height: 22px;
          & > span {
            &:first-child {
              padding-right: 6px;
            }
            &:last-child {
              flex: 1;
            }
          }
        }
      }
    }
  }
}
.barcodeMethodClass {
  font-size: 14px;
  display: flex;
  margin: 10px 0 0px 0;
  align-items: center;
  .p-title {
    margin-right: 8px;
  }
}
.singleBoxLi {
  padding: 10px 0;
  > div:nth-child(2) {
    margin-left: 4px;
    margin-right: 4px;
  }
  > div {
    width: 33.333%;
    display: flex;
    > :last-child {
      flex: 1;
    }
    > span:first-child {
    }
    .volume {
      max-width: initial !important;
      flex: 1;
    }
  }
}
.btnCls {
  display: flex;
  align-items: flex-end;
  > span {
    margin-right: 4px;
    flex: initial !important;
  }
  .btn {
    padding: 0 10px;
  }
}
.hiddenText {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.conventionalBox-info {
  font-size: 14px;
  .signInDetail-btnBox {
    background-color: #fbf9fe;
    padding: 10px;
    border-bottom: 1px solid #cccccc;
    li {
      white-space: nowrap;
      display: flex;
      align-items: baseline;
    }
    .volume {
      min-width: 10%;
      max-width: 27%;
      height: 22px;
      line-height: 22px;
      font-size: 12px;
      border: 0;
      background-color: #fbf9fe;
      border-bottom: 1px solid #757474;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }
    &:last-child {
      border-bottom: 0;
    }
  }
}
.sign-photo-box {
  margin: 5px 10px 10px;
  box-sizing: border-box;
  padding: 10px;
  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;
      box-shadow: 0px 0px 7px -1px #cccccc;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }
      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }
    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;
      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;
        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;
          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
.sign-photo-save {
  padding: 0 10px;
}
.photo {
  font-size: 14px;
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
}
.hidden {
  display: none;
}
.addInfo,
.delInfo {
  right: 1%;
  color: #027db4;
}
.delInfo {
  right: 13%;
  color: #da2727;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
  font-size: 14px;
}
.btn-other {
  height: 36px !important;
  min-width: 48% !important;
}
.add {
  border: 2px dashed #ccc;
  width: 100%;
  text-align: center;
  line-height: 15px;
  color: #ccc;
  margin: 5px 0;
}
.add:hover {
  border-color: rgb(151, 151, 151);
  color: rgb(151, 151, 151);
}
.btnBox-left {
  width: 100%;
  padding-right: 5px;
}
.btnBox-right {
  width: 100%;
  padding-left: 5px;
}
.tips {
  position: absolute;
  left: -50px;
  top: 33px;
  font-size: 12px;
  line-height: 20px;
}
.vm {
  vertical-align: middle;
}
</style>